import { render, staticRenderFns } from "./ChainCard.vue?vue&type=template&id=5a851c8b&scoped=true&"
import script from "./ChainCard.vue?vue&type=script&lang=ts&"
export * from "./ChainCard.vue?vue&type=script&lang=ts&"
import style0 from "./ChainCard.vue?vue&type=style&index=0&id=5a851c8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a851c8b",
  null
  
)

export default component.exports